export default __webpack_public_path__ + "static/media/fourth_img.0e653a7d.svg";